<template>
    <div class="select-time d-flex">
        <select class="form-select">
            <option>01</option>
            <option>02</option>
        </select>
        <select class="form-select">
            <option>01</option>
            <option>02</option>

        </select>
        <select class="form-select">
            <option>AM</option>
            <option>PM</option>
        </select>
    </div>
</template>
<script>
    export default {
        name: "time",
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {

        },

    }
</script>